import Vue from 'vue'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import loadHighchartsMore from 'highcharts/highcharts-more'

loadHighchartsMore(Highcharts)
Vue.use(HighchartsVue, { Highcharts })
